import React from "react";
import axios from "axios";
import Grid from '@mui/material/Grid';
import ActionAlert from "../Alert/ActionAlert.jsx";
import CardMarkerSmall from "./CardMarkerSmall.jsx";
import PathoCardAccordion from "../TextComps/PathoCardAccordion.jsx";
import TrafficlightButtonRed from "../Button/TrafficlightButtonRed.jsx";
import TrafficlightButtonGreen from "../Button/TrafficlightButtonGreen.jsx";
import TrafficlightButtonBlue from "../Button/TrafficlightButtonBlue.jsx";


export default function GeneticPanelsCardTemplate(props) {

const {panel_url, panel_name, panel_subtext } = props

const url_panel = {panel_url}
const [variantInfo, setVariantInfo] = React.useState(null);
const [error, setError] = React.useState(null);

React.useEffect(() => {retrievePanel();}, []);

const retrievePanel = () => {
  axios
    .get(url_panel.panel_url)
    .then((res) => {
      setVariantInfo(res.data);

    })
    .catch(function (error) {
      if (error.response) {
        // Request made and server responded
        setError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        setError("The request was made but no response was received.");
      } else {
        // Something happened in setting up the request that triggered an Error
        setError("Error: " + error.message);
      }
    });
};

return(
<>

{variantInfo ? 

      <CardMarkerSmall

        headline = {panel_name} 
        subtext = {panel_subtext}
        cardlines = {<>

        {variantInfo.map((i, index) => 
              
              <PathoCardAccordion key={index} 

                  name = {i.condition}
                  icon_1 = {i.traffic_light === 'red' ? <TrafficlightButtonRed /> : i.traffic_light === 'orange' ? <TrafficlightButtonBlue /> : <TrafficlightButtonGreen />}

                  panel = {i.panel}
                  condition = {i.condition}
                  mondo_id={"Condition ID:"}
                  mondo = { i.mondoID}
                  genes_id={"Genes:"}
                  genes = {i.genes}
                  variants_id={"Variants checked:"}
                  variants = {i.variants}
                  hit_id={"Important Variants found:"}
                  hits = {i.traffic_vars}
         />  
      )}  
      </>}

    />

 : 

    <Grid container mt={2} mb={2} justifyContent="center" rowspacing={2}>
        <Grid size={12}>
        <ActionAlert
            severity="warning"
            message={"Currently no information available"}
        />
        </Grid>
    </Grid>

}

{error && (
          <Grid container mt={2} mb={1} justifyContent="center" rowspacing={1}>
            <Grid size={12}>
              <ActionAlert severity="error" message={error.message} />
            </Grid>
          </Grid>
)}

</> 
)
}

